import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImageField } from '@sitecore-jss/sitecore-jss-react/types/components/Image';

import { getSharedArray, mapSharedPropertiesToFields } from 'common/getters';
import { withTheme } from 'common/jabraTheme/withTheme';
import { SitecoreFieldTypes } from 'common/types/sitecore';
import { BentoGridComponent } from 'composables/Product/BentoGrid/BentoGridComponent';
import { ComponentProps } from 'lib/component-props';

export interface BentoGridItem extends Record<string, unknown> {
  id: string;
  description: Field<string>;
  title: Field<string>;
  icon: ImageField;
  image: ImageField;
  iconDropList: Field<string>;
  longDescription: Field<string>;
  longTitle: Field<string>;
}
export interface BentoGrid {
  items: { fields: SitecoreFieldTypes; id: string }[];
  itemsShared: { fields: SitecoreFieldTypes; id: string }[];
}

type BentoGridProps = {
  fields: BentoGrid;
} & ComponentProps;

const BentoGrid = ({ fields }: BentoGridProps) => {
  const items = getSharedArray(fields, 'items');
  const parsedItems = items.map(({ fields, id }) => {
    const gridItem = mapSharedPropertiesToFields<BentoGridItem>(fields);
    return { ...gridItem, id };
  });

  return <BentoGridComponent items={parsedItems}></BentoGridComponent>;
};

export default withTheme({
  defaultTheme: {
    backgroundColor: '#627776',
    foregroundColor: 'white',
    darkTheme: true,
  },
})(withDatasourceCheck()<BentoGridProps>(BentoGrid));
